import React from 'react';
import {View} from 'react-native';

import {makeByLineText} from '../../../utils/products';
import Text from '../../ui-controls/Text';
import {infoStyles} from '../styles';
import {ProductTileInfoProps} from '../types';

function ProductTileInfo({
  item,
  showName = true,
  showByline = true,
  nameNumberOfLines = 2,
  containerStyle,
  nameStyle,
  bylineStyle,
  testID,
}: ProductTileInfoProps) {
  const byline = makeByLineText(item);

  return (
    <View style={[infoStyles.container, containerStyle]}>
      {showName ? (
        <Text
          style={[infoStyles.name, nameStyle]}
          numberOfLines={nameNumberOfLines}
          testID={testID}>
          {item.name}
        </Text>
      ) : null}
      {showByline && byline ? <Text style={[infoStyles.byline, bylineStyle]}>{byline}</Text> : null}
    </View>
  );
}

export default ProductTileInfo;
